import React from 'react';
import { Box, Grid, Fade, useTheme, useMediaQuery } from '@mui/material';
import DeckCard from './DeckCard';
import DeckListItem from './DeckListItem';

const DeckList = ({
    decks,
    viewMode,
    currentUser,
    isDeckFavorite,
    getUserDeckCategory,
    getCategoryColor,
    getCategoryLabel,
    onToggleFavorite,
    onCopyDeckList,
    onEditDeck,
    onDeleteDeck,
    onCategoryChange,
    onImageClick,
    onOpenQuickMatch
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));

    if (viewMode === 'list') {
        return (
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: isSmallMobile ? 1.5 : 1
            }}>
                {decks.map((deck) => (
                    <DeckListItem
                        key={deck.id}
                        deck={deck}
                        currentUser={currentUser}
                        isDeckFavorite={isDeckFavorite}
                        getUserDeckCategory={getUserDeckCategory}
                        getCategoryColor={getCategoryColor}
                        getCategoryLabel={getCategoryLabel}
                        onToggleFavorite={onToggleFavorite}
                        onCopyDeckList={onCopyDeckList}
                        onEditDeck={onEditDeck}
                        onDeleteDeck={onDeleteDeck}
                        onCategoryChange={onCategoryChange}
                        onImageClick={onImageClick}
                        onOpenQuickMatch={onOpenQuickMatch}
                    />
                ))}
            </Box>
        );
    }

    // Widok siatki - dostosowany do rozmiaru ekranu
    const getGridSizes = () => {
        if (isSmallMobile) {
            return { xs: 12 }; // Jedna kolumna na małych telefonach
        } else if (isMobile) {
            return { xs: 12, sm: 6 }; // Dwie kolumny na tabletach
        } else {
            return { xs: 12, sm: 6, md: 4, lg: 3 }; // Oryginalne rozmiary na desktopie
        }
    };

    return (
        <Grid container spacing={isSmallMobile ? 1.5 : 2}>
            {decks.map((deck) => (
                <Grid item {...getGridSizes()} key={deck.id}>
                    <Fade in={true} timeout={300}>
                        <div>
                            <DeckCard
                                deck={deck}
                                currentUser={currentUser}
                                isDeckFavorite={isDeckFavorite}
                                getUserDeckCategory={getUserDeckCategory}
                                getCategoryColor={getCategoryColor}
                                getCategoryLabel={getCategoryLabel}
                                onToggleFavorite={onToggleFavorite}
                                onCopyDeckList={onCopyDeckList}
                                onEditDeck={onEditDeck}
                                onDeleteDeck={onDeleteDeck}
                                onCategoryChange={onCategoryChange}
                                onImageClick={onImageClick}
                                onOpenQuickMatch={onOpenQuickMatch}
                            />
                        </div>
                    </Fade>
                </Grid>
            ))}
        </Grid>
    );
};

export default DeckList;
